const CHANNEL_ICONS = {
  3: require('../assets/channels/property_1_.png'),
  4: require('../assets/channels/property_1_gcash.png'),
  7: require('../assets/channels/property_1_gopay.png'),
  8: require('../assets/channels/property_1_ovo.png'),
  9: require('../assets/channels/property_1_dana.png'),
  10: require('../assets/channels/property_1_paypal.png'),
  11: require('../assets/channels/property_1_epay.png'),
  13: require('../assets/channels/property_1_qiwi.png'),
  14: require('../assets/channels/property_1_usdt.png'),
  16: require('../assets/channels/property_1_imps.png'),
  17: require('../assets/channels/property_1_upi.png'),
  18: require('../assets/channels/property_1_jazz_cash.png'),
  19: require('../assets/channels/property_1_easypaisa.png')
}

export function getChannelIcon(withdrawType) {
  return CHANNEL_ICONS[withdrawType] || ''
}



// WEBPACK FOOTER //
// ./src/utils/channelIcons.js